import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ShieldCheck, Warning, Clock, Fire } from "@phosphor-icons/react";

const COLORS = {
  green: { bg: "#EDF3F0", border: "#0F4C3A", text: "#0F4C3A", label: "Saudável" },
  yellow: { bg: "#FEF3C7", border: "#D97706", text: "#D97706", label: "Atenção" },
  red: { bg: "#FEE2E2", border: "#DC2626", text: "#DC2626", label: "Risco" },
};

export default function ConnectionHealth({ connectionId }) {
  const [h, setH] = useState(null);

  useEffect(() => {
    if (!connectionId) return;
    const fetch = async () => {
      try {
        const { data } = await api.get(`/whatsapp/connections/${connectionId}/health`);
        setH(data);
      } catch { /* ignore */ }
    };
    fetch();
    const t = setInterval(fetch, 15000); // refresh every 15s
    return () => clearInterval(t);
  }, [connectionId]);

  if (!h) return null;
  const c = COLORS[h.score] || COLORS.green;

  return (
    <div
      className="border-l-[3px] p-3 text-xs"
      style={{ background: c.bg, borderColor: c.border }}
      data-testid={`health-widget-${connectionId}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1.5 font-bold" style={{ color: c.text }}>
          {h.score === "red" ? <Warning size={14} weight="fill" /> : <ShieldCheck size={14} weight="fill" />}
          Anti-ban: {c.label}
        </div>
        {h.warming && (
          <span className="flex items-center gap-1 text-[10px] font-mono" style={{ color: c.text }}>
            <Fire size={11} weight="fill" /> Aquecimento {h.warmup_hours_left.toFixed(1)}h
          </span>
        )}
      </div>
      <div className="grid grid-cols-2 gap-x-4 gap-y-1 mt-2 text-[10px] text-[#5C5C59]">
        <span className="flex items-center gap-1">
          <Clock size={10} /> Último min: <b className="text-[#1A1A1A] font-mono">{h.sent_last_minute}/{h.limit_per_minute}</b>
        </span>
        <span className="flex items-center gap-1">
          <Clock size={10} /> Última hora: <b className="text-[#1A1A1A] font-mono">{h.sent_last_hour}/{h.limit_per_hour}</b>
        </span>
      </div>
    </div>
  );
}
